import { api } from './client'

export type TimeNaLista = {
  id: number
  idExterno: number
  nome: string

  /** O que o time atende, em português. É o que o modelo lê para escolher. */
  descricao: string

  /** Sumiu do Chatwoot na última sincronização. Não é apagado: pode haver regra apontando para ele. */
  ausente: boolean

  /**
   * Este time entra na lista fechada que vai ao assistente?
   *
   * 🔴 **O campo era lido em três lugares do back e escrito em nenhum** — e uma
   * migration o criou em `false` para todos os onze times da Rio DG, o que
   * desligou o transbordo dos dois assistentes por sete dias sem nenhum erro
   * (demanda 141). Time fora do automático continua recebendo transferência
   * manual.
   */
  destinoDoAtendimento: boolean

  sincronizadoEm: string | null
}

export type ResultadoDaSincronizacao = {
  sucesso: boolean
  criados: number
  atualizados: number
  ausentes: number
  erro: string | null
}

/**
 * Times de atendimento — o destino de um transbordo.
 *
 * 🔴 A lista **vem do Chatwoot**; a descrição é do portal. Sincronizar atualiza
 * nome e presença e não toca na descrição, porque é ela que decide o
 * roteamento por assunto.
 *
 * Sincronizar que falha devolve **200 com `sucesso: false`**, e não erro: a
 * lista em cache continua valendo, e a tela precisa dizer isso em vez de sumir.
 */
export const times = {
  listar: () => api.get<TimeNaLista[]>('/times'),

  sincronizar: () => api.post<ResultadoDaSincronizacao>('/times/sincronizar', {}),

  descrever: (id: number, descricao: string) =>
    api.put<{ id: number; nome: string; descricao: string }>(`/times/${id}/descricao`, {
      descricao,
    }),

  definirDestino: (id: number, destino: boolean) =>
    api.put<{ id: number; nome: string; destinoDoAtendimento: boolean }>(
      `/times/${id}/destino`,
      { destino },
    ),
}
